<template>
    <div class="common-modal order_modal_con booking_contact_modal" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="common-modal-dialog" style="width: 490px">
            <img class="common-modal-close close_booking_contact_modal"  @click="onModalClose" src="https://resource.rcclchina.com.cn/tui2/list/modal-close.png">
            <div class="booking_contact_con">
                <div class="pspt_title">修改联系人信息</div>
                <div class="pspt_num_con">
                    <span>姓<span style="margin-left: 42px;">名</span></span>
                    <input type="text" class="left_distance" data-key="Name" v-model="bookingContact.name" @focus="txtFocus" placeholder="姓名" name="" id="contactName">
                </div>
                <div class="pspt_num_con">
                    <span>手<span style="margin-left: 14px;">机</span><span style="margin-left: 14px;">号</span></span>
                    <input type="text" class="left_distance" data-key="Telephone" v-model="bookingContact.telephone" @focus="txtFocus" placeholder="手机号" name=""
                           id="contactTelephone">
                </div>
                <div class="pspt_num_con picCode" v-show="needSmsCode">
                    <span>图形验证码</span>
                    <input type="text" placeholder="图形验证码" maxlength="4" name="" data-key="PicCode" id="picCode" v-model="picCode">
                    <img id="p_code" class="p_code" :src="picCodeImage">
                    <a class="change_picCode" @click="getPicCode">换一换</a>
                </div>
                <div class="pspt_num_con smsCode" v-show="needSmsCode">
                    <span>短信验证码</span>
                    <input type="text" placeholder="短信验证码" maxlength="6" name="" data-key="SmsCode" id="smsCode" v-model="smsCode">
                    <button type="submit" class="btn get_code" id="sendVeriCode" @click="onSmsClick">{{smsCodeText}}</button>
                </div>
                <div class="pspt_num_con">
                    <span>邮<span style="margin-left: 42px;">箱</span></span>
                    <input v-model="bookingContact.email" data-key="Email" @focus="txtFocus" type="text" class="left_distance" placeholder="邮箱" name="" id="contactEmail">
                </div>

                <div class="btns_con">
                    <input type="button" class="close_booking_contact_modal" style="text-align: center;" name="" value="取消" @click="onModalClose">
                    <input class="btn_sure submit-booking-contact" type="button" name="" value="确定" @click="submitContact">
                </div>
            </div>
        </div>
        <div id="captchaElement"></div>
        <button id="captchaTrigger" type="button" style="display:none"></button>
    </div>
</template>

<script>
import api from '@/api'
import { clone } from '@/utilities/tools'
const SCENE_ID = 'tqbrb5ax';
export default {
    name: "ChangeBookingContact",
    props: {
        contact: {
            type: Object
        },
        bookingId: {
            type: String
        },
        isShow: {
            type: Boolean
        },
        changeContact: {
            type: Function
        }
    },
    data () {
        return {
            smsCodeCountDown: 0,
            picCodeImage: '',
            callingCodes: [],
            oldTelephone: {

            },
            bookingContact: {
                name: '',
                bookingId: '',
                email: '',
                telephone: '',
                callingCode: '86',
                id: 0
            },
            picCode: "",
            smsCode: "",
            selectedCallingCode: {},
            updateFields: [],
            isMaskValue: true,

            captcha: null,
            loadingSms:false,
        }
    },
    beforeMount () {
        this.getCallingCodes()
        this.getPicCode()
    },
    methods: {
        initPage () {
            if (this.contact){
                let name = this.contact.chineseLastName + this.contact.chineseFirstName
                if (name == '') {
                    name = this.contact.pinYinLastName + ' ' + this.contact.pinYinFirstName
                }
                this.bookingContact = {
                    name: name,
                    bookingId: this.bookingId,
                    email: this.contact.email,
                    telephone: this.contact.telephone,
                    callingCode: this.contact.callingCode || '86',
                    id: this.contact.id
                }
                this.oldTelephone = {
                    telephone: this.contact.telephone,
                    callingCode: this.contact.callingCode || '86'
                }
                this.selectedCallingCode = this.getCallingCode(this.contact.callingCode || '86')
            }
            this.$nextTick(()=>{
                // 初始化阿里云
                this.initCaptcha();
            })
        },
        // 阿里云验证 start
        // 验证码初始化
        initCaptcha () {
                if (!window.initAliyunCaptcha) return
        window.initAliyunCaptcha({
            SceneId: SCENE_ID,
            // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
            mode: "popup",
            // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
            element: "#captchaElement",
            // 触发验证码弹窗或无痕验证的元素
            button: '#captchaTrigger',
            // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
            slideStyle: {
            width: 360,
            height: 40,
            },
            // 验证码验证通过回调函数
            success: this.onCaptchaSuccess,
            // 验证码验证不通过回调函数
            fail: this.captchaFail,
            // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
            getInstance: (instance) => {
            this.captcha = instance
            }
        });
            },
        captchaFail() {
            this.loadingSms = false
        },
        onSmsClick() {
            if (this.smsCodeCountDown > 0) {
                return;
            }
            if (this.loadingSms) return
            this.loadingSms = true
            document.getElementById('captchaTrigger').click()
        },
        onCaptchaSuccess(captchaRes) {
            // 刷新
            this.captcha && this.captcha.refresh();
            this.captchaSuccessSms(captchaRes)
        },
        async captchaSuccessSms(captchaVerifyParam) {
            try {
                this.$loading.show();
                await this.sendSmsCode("AliYunAfsNc", captchaVerifyParam);
            } finally {
                this.resetCaptcha()
            }
        },
        resetCaptcha() {
            if (this.captcha && typeof this.captcha.refresh === 'function') {
                this.captcha.refresh()
            }
            this.loadingSms = false
        },
        // 阿里云验证 end
        async getCallingCodes () {
            const { success, data, errMsg } = await api.page.getCallingCode()
            if (!success) console.error(errMsg)
            this.callingCodes = data
        },
        // 获取图形验证码
        async getPicCode () {
            const { success, data, errMsg } = await api.user.picCode(this.smsKey)
            if (!success) console.error(errMsg)
            if (data) {
                this.picCodeImage = "data:image/png;base64," + data.imageBase64
                this.$store.dispatch('SET_SESSION_KEY', data.sessionKey)
            }
        },
        // 获取短信验证码
        async sendSmsCode (codeType, codeValue){
            
            let callingCode = this.bookingContact.callingCode
            if (callingCode && callingCode.length > 1 && callingCode.indexOf("+") == 0) {
                callingCode = callingCode.substring(1)
            }
            const { success, errMsg } = await api.user.SendSmsCodeWithPicCodeV3({
                phone: this.bookingContact.telephone,
                picCode: this.picCode,
                callingCode: callingCode,
                sessionKey: this.smsKey,
                codeType:codeType,
                captchaVerifyParam: codeValue,
                sceneId:SCENE_ID
            })
            if (!success) {
                console.error(errMsg)
                this.$alert.show(errMsg)
                
            } else {
                this.$alert.show("短信发送成功！若您没有收到短信验证，请一分钟后重新发送。")
                this.smsCodeCountDown = 60
                const self = this
                let countDown = setInterval(()=> {
                    if (self.smsCodeCountDown == 0) {
                        clearInterval(countDown)
                    } else {
                        self.smsCodeCountDown--
                    }
                }, 1000)
            }
            this.$loading.hide()
            this.getPicCode()
            
        },
        async submitContact () {
            let data = clone(this.bookingContact)
            data.code = this.smsCode
            data.UpdateFields = this.updateFields

            if(this.updateFields.length === 0) {
              return this.$alert.show('没有任何修改')
            }

            if (!data.name || data.name == '' || data.name.length < 2) {
                return this.$alert.show("请输入正确的联系人姓名")
            } else if (!data.telephone || data.telephone == '') {
                return this.$alert.show("请输入联系人手机号")
            } else if (!data.email || data.email == '') {
                return this.$alert.show("请输入联系人邮箱")
            }

            if(!this.isMaskValue || this.updateFields.includes('Telephone')) {
              if (this.needSmsCode && (!data.code || data.code == '')) {
                return this.$alert.show("请输入短信验证码")
              }
            }

            const requestData = {
                model: data,
                sessionKey: this.smsKey
            }

            console.log(requestData)
            this.$loading.show()
            const { success, errMsg } = await api.booking.changeBookingContact(requestData) 
            this.$loading.hide()
            if (!success) {
              console.log(errMsg)
                return this.$alert.show(errMsg)
            } else {
                const self = this
                this.$alert.show('修改成功', {
                    confirmCallBack: ()=> {
                        let contact = {
                            callingCode: data.callingCode,
                            telephone: data.telephone,
                            email: data.email,
                            chineseLastName: data.name.substring(0, 1),
                            chineseFirstName: data.name.substring(1, data.name.length),
                            id: data.id,
                            UpdateFields: this.updateFields
                        }
                        self.changeContact(contact)
                    }
                })
            }
        },
        getCallingCode (code) {
            if (code.indexOf('+') < 0) {
                code = '+' + code
            }
            return this.callingCodes.find(r=>r.callingCode == code)
        },
        onCallingCodeChange (e) {
            const value = e.target.value
            const callingCode = this.callingCodes.find(r=> r.callingCode == value)
            if (callingCode) {
                this.selectedCallingCode = callingCode
            }
        },
        onModalClose () {
            this.$emit('onModalClose')
        },
        txtFocus(e) {
          let dataKey = e.target.getAttribute('data-key')
          if (this.isMaskValue) {
            switch (dataKey) {
              case 'Name':
                if(!this.updateFields.includes("ChineseLastName") || !this.updateFields.includes("ChineseFirstName")) {
                  this.bookingContact.name = "";
                  this.updateFields.push("ChineseLastName");
                  this.updateFields.push("ChineseFirstName");
                }
                break;
              case 'Telephone':
                if(!this.updateFields.includes("Telephone")) {
                  this.bookingContact.telephone = "";
                  this.updateFields.push("Telephone");
                }
                break;
              case 'Email':
                if(!this.updateFields.includes("Email")) {
                  this.bookingContact.email = "";
                  this.updateFields.push("Email");
                }
                break;
            }
          }

          if(dataKey === "Name" && (!this.updateFields.includes("ChineseLastName") || !this.updateFields.includes("ChineseFirstName"))) {
            this.updateFields.push("ChineseLastName");
            this.updateFields.push("ChineseFirstName");
          } else if(!this.updateFields.includes(dataKey)) {
            if(dataKey !== "Name") this.updateFields.push(dataKey);
          }
        }
    },
    computed: {
        smsKey() {
            return this.$store.state.page.sessionKey
        },
        smsCodeText () {
            if (this.smsCodeCountDown <= 0) {
                return "发送验证码"
            } else {
                return `验证码(${this.smsCodeCountDown}s)`
            }
        },
        needSmsCode () {
            const userMobile = this.$store.state.user.userInfo.mobile            
            return userMobile != this.bookingContact.telephone && 
            (this.bookingContact.telephone != this.oldTelephone.telephone 
            || this.bookingContact.callingCode != this.oldTelephone.callingCode)
        }
    },
    watch: {
        isShow (newValue) {
            if (newValue) {
                this.initPage()
            }
            this.updateFields = []
            this.isMaskValue = this.$store.state.page.isMaskValue;
        }
    }
}
</script>

<style lang="less" scoped>

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.order_modal_con {
    background-color: transparent;
}

.order_modal_con .common-modal-dialog {
    overflow: initial;
}

.order_modal_con .passport_con {
    background-color: #fff;
    border-radius: 5px;
}

.order_modal_con .passport_con .pspt_title {
    font-size: 18px;
    font-weight: 600;
    color: #282b2c;
    padding: 17px 22px;
}

.order_modal_con .passport_con .pspt_name {
    font-size: 14px;
    color: #282b2c;
    line-height: 18px;
    padding: 0 22px;
    margin-bottom: 17px;
}

.order_modal_con .passport_con .pspt_num_con {
    padding: 0 22px;
    font-size: 14px;
    color: #747d80;
    vertical-align: center;
    margin-bottom: 10px;
    position: relative;
    display: inline-block;
}

.order_modal_con .passport_con .pspt_num_con .calendar_icon {
    position: absolute;
    top: 8px;
    right: 30px;
}

.order_modal_con .passport_con .pspt_num_con input {
    height: 36px;
    width: 247px;
}

.order_modal_con .passport_con .pspt_mark {
    font-size: 12px;
    color: #ff3022;
    padding: 10px 22px;
    text-align: center;
}

.order_modal_con .passport_con .btns_con {
    padding: 10px 0;
    width: 100%;
    background-color: #f3f6f8;
    border-top: 1px solid #d3dadd;
    text-align: center;
}

.order_modal_con .passport_con .btns_con input {
    width: 78px;
    height: 30px;
    background-color: #ffffff;
    border: solid 1px #d3dadd;
}

.order_modal_con .passport_con .btns_con .btn_sure {
    background-color: #006ab9;
    color: #fff;
}

.order_modal_con .passport_con input {
    font-style: normal;
    padding-left: 5px;
    margin-left: 5px;
    border-top: none;
    border-left: none;
    border-right: none;
}

.msg_prompt {
    padding-left: 16px;
    margin-top: -11px;
    margin-bottom: 7px;
}

.msg_prompt span {
    font-size: 12px;
}


.order_modal_con .common-modal-dialog {
    overflow: initial;
  }
  
  .order_modal_con .booking_contact_con {
    background-color: #fff;
  }
  .order_modal_con .booking_contact_con .pspt_title {
    font-size: 18px;
    font-weight: 600;
    color: #282b2c;
    padding: 17px 22px;
  }
  .order_modal_con .booking_contact_con .pspt_name {
    font-size: 14px;
    color: #282b2c;
    line-height: 18px;
    padding: 0 22px;
    margin-bottom: 17px;
  }
  .order_modal_con .booking_contact_con .pspt_num_con {
    padding: 0 22px;
    font-size: 14px;
    color: #747d80;
    vertical-align: center;
    margin-bottom: 10px;
    position: relative;
  }

  .order_modal_con .booking_contact_con .pspt_num_con >span {
      display: inline-block;
      min-width: 42px;
  }
  
  .order_modal_con .booking_contact_con .pspt_num_con .calendar_icon {
    position: absolute;
    top: 8px;
    left: 286px;
  }
  
  .order_modal_con .booking_contact_con .pspt_num_con input {
    height: 36px;
    width: 247px;
    border: 1px solid #d7dde0;
    color: #282b2c;
  }
  .order_modal_con .booking_contact_con .pspt_mark {
    font-size: 14px;
    color: #ff3022;
    padding: 10px 22px;
  }
  .order_modal_con .booking_contact_con .btns_con {
    padding: 10px 0;
    width: 100%;
    background-color: #f3f6f8;
    border-top: 1px solid #d3dadd;
    text-align: center;
  }
  .order_modal_con .booking_contact_con .btns_con input {
    width: 78px;
    height: 30px;
    background-color: #ffffff;
    border: solid 1px #d3dadd;
  }
  .order_modal_con .booking_contact_con .btns_con .btn_sure {
    background-color: #006ab9;
    color: #fff;
  }
  .order_modal_con .booking_contact_con input {
    font-style: normal;
    padding-left: 5px;
    margin-left: 5px;
  }

.order_modal_con .booking_contact_con .pspt_num_con .left_distance {
    margin-left:5px;
}

.p_code{
    padding-left:5px;
}

.change_picCode{
    position:relative;
    padding-left:1px;
    cursor:pointer;
}

.get_code{
    margin-left:5px;
    background: #006ab9;
    color: #fff;
}
.get_code:hover{
    color: #fff;
}
.get_code.active{
    background: #ddd;
    color: #282b2c;
}



</style>